export interface DDA {
  CFIGFILIAL : string;
  DFIGDATA : Date | undefined;
  CFIGFORNEC : string;
  CFIGLOJA : string;
  CFIGNOMFOR : string;
  CFIGTITULO : string;
  CFIGTIPO : string;
  DFIGVENCTO : Date | undefined;
  NFIGVALOR : number;
  CFIGCONCIL : string;
  DFIGDTCONC : Date | undefined;
  CFIGUSCONC : string;
  CFIGDDASE2 : string;
  CFIGCNPJ : string;
  CFIGCODBAR : string;
  NFIGRECNO: number
}

export interface DDALista {
  items: Array<DDA>;
  hasNext: boolean;
}


export const defaultDDA = (): DDA => {
  return {
    CFIGFILIAL : '' ,
    DFIGDATA : undefined,
    CFIGFORNEC : '' ,
    CFIGLOJA : '' ,
    CFIGNOMFOR : '' ,
    CFIGTITULO : '' ,
    CFIGTIPO : '' ,
    DFIGVENCTO : undefined,
    NFIGVALOR : 0,
    CFIGCONCIL : '' ,
    DFIGDTCONC : undefined,
    CFIGUSCONC : '' ,
    CFIGDDASE2 : '' ,
    CFIGCNPJ : '' ,
    CFIGCODBAR : '' ,
    NFIGRECNO : 0,
  };
};


